import React, { Component } from "react";

export default class ArchiveResultCount extends Component {
    render() {
        return (
            <h2 className="message__content" role="status">
                <span className="message__content--highlight">
                    {" "}
                    {this.props.resultCount}
                </span>{" "}
                {this.props.resultCount === 1
                    ? "organisatie gevonden"
                    : "organisaties gevonden"}
            </h2>
        );
    }
}
